import {Injectable} from '@angular/core';
import {I18NextPipe} from 'angular-i18next';
import {LocalAlertsService} from 'app/core/services/alerts/local-alerts.service';
import {AuthService} from 'app/core/services/auth.service';
import {DemoService} from 'app/core/services/demo.service';
import {LocalStorageService} from 'app/core/services/local-storage.service';
import {AppList} from 'app/features/apps/interfaces/app-list.interface';
import {boolDevFlag} from 'test-helpers/dev-flags';

@Injectable()
export abstract class AppStatusesService {
    private isShownOnTab = false;

    constructor(
        protected localeAlerts: LocalAlertsService,
        protected localStorage: LocalStorageService,
        protected i18next: I18NextPipe,
        protected demo: DemoService,
        protected auth: AuthService
    ) {}

    abstract key(): string;

    get isUserClosedNotification(): boolean {
        return boolDevFlag(this.key(), false, this.localStorage);
    }

    get isShownNotificationInTab(): boolean {
        return this.isShownOnTab;
    }

    abstract shouldShowNotification(apps: AppList): boolean;

    markAsShown() {
        this.isShownOnTab = true;
    }

    public markAsClosed() {
        this.localStorage.setItem(this.key(), '1');
    }

    abstract showWarning(): void;

    async checkWarnings(apps: AppList) {
        if (this.demo.isDemoHost || this.isShownNotificationInTab || this.isUserClosedNotification || !this.shouldShowNotification(apps)) {
            return;
        }

        this.showWarning();
        this.markAsShown();
    }
}
